import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-rating-input',
  templateUrl: './rating-input.component.html',
  styleUrl: './rating-input.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RatingInputComponent),
      multi: true
    }
  ]
})
export class RatingInputComponent implements ControlValueAccessor, OnInit {
  @Input() maxRating = 5;

  value = 0;
  hoveredRating = 0;
  disabled = false;

  stars: number[] = [];

  private onChange: (value: number) => void = () => {
    /* noop */
  };
  private onTouched: () => void = () => {
    /* noop */
  };

  ngOnInit(): void {
    this.stars = Array(this.maxRating)
      .fill(0)
      .map((_, i) => i + 1);
  }

  writeValue(value: number): void {
    this.value = value || 0;
  }

  registerOnChange(fn: (value: number) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  selectRating(rating: number): void {
    if (!this.disabled) {
      this.value = rating;
      this.onChange(rating);
      this.onTouched();
    }
  }

  onMouseEnter(rating: number): void {
    if (!this.disabled) {
      this.hoveredRating = rating;
    }
  }

  onMouseLeave(): void {
    this.hoveredRating = 0;
  }

  isStarFilled(star: number): boolean {
    return star <= (this.hoveredRating || this.value);
  }
}
